import { Collection } from "@type-r/models";
import { asCurrency, asTimelessDate, Column, Columns, Flex } from "lqx-react";
import React from "react";
import { CreditNoteChange } from "../../api/creditNoteChange";
import { AssetTileStatusField, AssetTileField, AssetTileHeaderField, CheckboxColumn, FirstColumn, SecondColumn, TileContainer, useAssetTileClasses, EventsColumn } from "../../components/asset-section-styles";
import { DigiCheckbox, DigiTooltip, limitText } from "../../shared";
import { InblockedAssetsEventStatus } from "../inblocked-assets-event-status";
import { CreditNoteExternalSystems } from "./externalSystems";

export const CreditNoteTile = ($active, selected: Collection<CreditNoteChange>, selectAllAssets) => (({ data, index, style }) => {
    const creditNoteChange: CreditNoteChange = data.items[index];
    const classes = useAssetTileClasses({ isSelected: $active.value && $active.value.id === creditNoteChange.id });
    const $checked = selected ? selected.$includes(creditNoteChange) : null;

    const onCreditNoteClicked = creditNote => $active.set(creditNote);

    return (<>
        <div key={creditNoteChange.id} style={style} className={classes.root} onClick={() => onCreditNoteClicked(creditNoteChange)}>
            <TileContainer>
                <Columns>
                    {selectAllAssets.value &&
                        <CheckboxColumn>
                            <DigiCheckbox checked={true} disabled={true} />
                        </CheckboxColumn>
                    }
                    {$checked && !selectAllAssets.value &&
                        <CheckboxColumn>
                            <DigiCheckbox $checked={$checked} disabled={selectAllAssets.value} />
                        </CheckboxColumn>
                    }
                    <Column>
                        <Flex row>
                            <Columns>
                                <EventsColumn>
                                    <Flex row>
                                        <InblockedAssetsEventStatus externalSystems={CreditNoteExternalSystems} assetChange={creditNoteChange} />
                                    </Flex>
                                    <Flex row>
                                        {/* <>DummyCell</> */}
                                    </Flex>
                                </EventsColumn>
                                <FirstColumn>
                                    <Flex row>
                                        <AssetTileStatusField> {creditNoteChange.state.name}</AssetTileStatusField>
                                    </Flex>
                                    <Flex row>
                                        <AssetTileField>Issuance Date {asTimelessDate(creditNoteChange.issuanceDate)}</AssetTileField>
                                    </Flex>
                                </FirstColumn>
                                <SecondColumn>
                                    <DigiTooltip title={`${creditNoteChange.supplier.name} - ${creditNoteChange.buyer.name}`}>
                                        <AssetTileHeaderField >{limitText(creditNoteChange.supplier.name, 60)} - {limitText(creditNoteChange.buyer.name, 60)}</AssetTileHeaderField>
                                    </DigiTooltip>
                                    <Flex row>
                                        <AssetTileField>Amount {asCurrency(creditNoteChange.amount)} {creditNoteChange.currency}</AssetTileField>
                                    </Flex>
                                </SecondColumn>
                            </Columns>
                        </Flex>
                    </Column>
                </Columns>
            </TileContainer>
        </div >
    </>
    )
})
